import produce from 'immer';
import {
  BRIDGE_WALLET_INFO_REQUEST,
  CAR_BOX_INFO_LIST_REQUEST,
  CAR_INFO_LIST_REQUEST,
  NFT_GEAR_INFO_LIST_REQUEST,
  WALLET_INFO_LIST_REQUEST,
} from '../../constants/monitoring/nftInfoConstants';

const initialState = {

};

const nftInfoReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case CAR_INFO_LIST_REQUEST:
      break;
    case CAR_BOX_INFO_LIST_REQUEST:
      break;
    case WALLET_INFO_LIST_REQUEST:
      break;
    case NFT_GEAR_INFO_LIST_REQUEST:
      break;
    case BRIDGE_WALLET_INFO_REQUEST:
      break;
    default:
      break;
  }
});

export default nftInfoReducer;
